import projectConfig from "../../config/resources/project";

export const getProjects = (state) => state.projects?.list ?? [];

export const getProjectsById = (state) => state.projects?.listById ?? {};

export const getProjectData = (state, id) =>
    state?.projects?.list.find((project) => project.id === id);

export const getActiveProjectId = (state) => {
    return state?.projects?.activeId;
};

export const getDefaultProjectId = (state) =>
    state?.projects?.list?.find((project) => project.name === projectConfig.defaultProjectName)?.id;

export const getActiveOrDefaultProjectId = (state) => {
    const id = state?.projects?.activeId ? state?.projects?.activeId : getDefaultProjectId(state);

    return id;
};
